export const placesKeys = {
  all: ['places'] as const,
}
